import React from 'react'

const ChoiceStaffPlanning = ({ valuesPlanning, staff, _choiceStaff }) => {

    const _addStaff = () => {
        if (valuesPlanning.surnameStaff === '') {
            staff.map((st,i) => (
                i === 0 && _choiceStaff(st.id, st.surnameStaff, st.nameStaff) 
            ))
        }
        return null
    }

    return (
        <div className='row'> 
            <div style={{ top: "4rem", position: "fixed", width: "100%", backgroundColor:'white' }}>
                <div style={{ display:'flex', flexDirection:'row', alignItems:'baseline', height:'3rem', flexWrap:'wrap' }} className='border-top pt-3'>
                    {staff.map(st => ( 
                        _addStaff() === null &&
                        <div key={st.id} onClick={() => _choiceStaff(st.id, st.surnameStaff, st.nameStaff)}
                            style={valuesPlanning.surnameStaff === st.surnameStaff ? 
                            { fontSize:25 } : 
                            { fontSize:18 }} 
                        >
                            <span style={ valuesPlanning.surnameStaff === st.surnameStaff ? 
                                {display:'inline-block', borderLeft:'solid', height:25, borderWidth:6, marginLeft:'0.8rem', marginRight:'0.3rem', borderColor:'#'+st.circleColor} :
                                {display:'inline-block', borderLeft:'solid', height:18, borderWidth:4, marginLeft:'1rem', marginRight:'0.3rem', borderColor:'#'+st.circleColor }
                            }></span>
                        {st.surnameStaff}</div>
                    ))}
                </div>
                <div style={{ height:'1rem'}} />
            </div>
        </div>
    )
}

export default ChoiceStaffPlanning

/*


*/